<template>
  <section class="v event-overview">
    <v-layout row wrap>
      <v-flex
        xs12
        md6
      >
        <simple-statistic
          :value="`
            ${duration.hours < 10 ? '0' : ''}
            ${duration.hours}:${duration.minutes < 10 ? '0' : ''}
            ${duration.minutes}:${duration.seconds < 10 ? '0' : ''}
            ${duration.seconds}
          `"
          label="Stunden / Minuten / Sekunden ohne Störung"
          class="text-center"
        />
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <simple-statistic
          :value="stats.numberOfEvents"
          label="Anzahl Ereignisse"
          class="text-center"
        />
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <simple-statistic
          :value="stats.numberOfUnresolvedEvents"
          label="Anzahl unbehobene Ereignisse"
          class="text-center"
        />
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <simple-statistic
          :value="stats.numberOfResolvedEvents"
          label="Anzahl behobene Ereignisse"
          class="text-center"
        />
      </v-flex>
      <v-flex xs12>
        <v-btn color="primary" @click="resolveAllEvents">
          Alle Ereignisse lösen
        </v-btn>
        <v-btn
          color="primary"
          flat
          icon
          @click="reloadEvents"
        >
          <v-icon>autorenew</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-btn-toggle v-model="filterEvents">
          <v-btn flat color="primary">
            Alle Ereignisse
          </v-btn>
          <v-btn flat color="primary">
            Nur ungelöste
          </v-btn>
          <v-btn flat color="primary">
            Nur Errors
          </v-btn>
        </v-btn-toggle>
      </v-flex>
      <v-flex v-if="filterEvents === 0" xs12>
        <v-list two-line>
          <template v-for="(item, index) in allEvents">
            <v-list-tile
              :key="`${JSON.stringify(item.message)}-${index}`"
              avatar
              ripple
              :class="{
                'is-unresolved': !item.resolved,
                'is-critical': item.severity === 'critical',
                'is-warning': item.severity === 'warning',
                'is-ok': item.severity === 'ok',
              }"
            >
              <v-list-tile-content @click="openGridArea(item.area.id)">
                <v-list-tile-title>{{ item.area.label }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                  {{ item.message }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <span v-if="item.resolved">GELÖST | </span>
                  <span v-else>UNGELÖST | </span>
                  <span v-if="item.severity === 'critical'">Kritisch</span>
                  <span v-else-if="item.severity === 'warning'">Warnung</span>
                  <span v-else>OK</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>
                  {{ $moment(item.inserted_at).format('DD.MM.YYYY HH:mm:ss') }}
                </v-list-tile-action-text>
                <v-icon
                  v-if="!item.resolved"
                  color="grey lighten-1"
                  @click="resolveEvent(item, index)"
                >
                  check_box_outline_blank
                </v-icon>

                <v-icon
                  v-else
                  color="green darken-2"
                >
                  check_box
                </v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < allEvents.length"
              :key="index"
            />
          </template>
        </v-list>
      </v-flex>
      <v-flex v-if="filterEvents === 1" xs12>
        <v-list two-line>
          <template v-for="(item, index) in allEvents">
            <v-list-tile
              v-if="!item.resolved"
              :key="`${JSON.stringify(item.message)}-${index}`"
              avatar
              ripple
              :class="{
                'is-unresolved': !item.resolved,
                'is-critical': item.severity === 'critical',
                'is-warning': item.severity === 'warning',
                'is-ok': item.severity === 'ok',
              }"
            >
              <v-list-tile-content @click="openGridArea(item.area.id)">
                <v-list-tile-title>Messwert: {{ item.type }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                  {{ item.message }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <span v-if="item.resolved">GELÖST | </span>
                  <span v-else>UNGELÖST | </span>
                  <span v-if="item.severity === 'critical'">Kritisch</span>
                  <span v-else-if="item.severity === 'warning'">Warnung</span>
                  <span v-else>OK</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>
                  {{ $moment(item.inserted_at).format('DD.MM.YYYY HH:mm:ss') }}
                </v-list-tile-action-text>
                <v-icon
                  v-if="!item.resolved"
                  color="grey lighten-1"
                  @click="resolveEvent(item, index)"
                >
                  check_box_outline_blank
                </v-icon>

                <v-icon
                  v-else
                  color="green darken-2"
                >
                  check_box
                </v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              v-if="!item.resolved"
              :key="index"
            />
          </template>
        </v-list>
      </v-flex>
      <v-flex v-if="filterEvents === 2" xs12>
        <v-list two-line>
          <template v-for="(item, index) in allEvents">
            <v-list-tile
              v-if="item.severity === 'critical'"
              :key="`${JSON.stringify(item.message)}-${index}`"
              avatar
              ripple
              :class="{
                'is-unresolved': !item.resolved,
                'is-critical': item.severity === 'critical',
                'is-warning': item.severity === 'warning',
                'is-ok': item.severity === 'ok',
              }"
            >
              <v-list-tile-content @click="openGridArea(item.area.id)">
                <v-list-tile-title>Messwert: {{ item.type }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                  {{ item.message }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <span v-if="item.resolved">GELÖST | </span>
                  <span v-else>UNGELÖST | </span>
                  <span v-if="item.severity === 'critical'">Kritisch</span>
                  <span v-else-if="item.severity === 'warning'">Warnung</span>
                  <span v-else>OK</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>
                  {{ $moment(item.inserted_at).format('DD.MM.YYYY HH:mm:ss') }}
                </v-list-tile-action-text>
                <v-icon
                  v-if="!item.resolved"
                  color="grey lighten-1"
                  @click="resolveEvent(item, index)"
                >
                  check_box_outline_blank
                </v-icon>

                <v-icon
                  v-else
                  color="green darken-2"
                >
                  check_box
                </v-icon>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              v-if="item.severity === 'critical'"
              :key="index"
            />
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import SimpleStatistic from '../components/Statistics/SimpleStatistic.vue';

export default {
  name: 'EventOverview',

  components: {
    SimpleStatistic,
  },

  data() {
    return {
      filterEvents: 0,
      today: '123',
      loadingDuration: true,
      duration: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      interval: null,
    };
  },

  computed: {
    allEvents() {
      return this.$store.state.gridAreas.allEvents;
    },
    stats() {
      return this.$store.state.gridAreas.stats;
    },
  },

  watch: {
    allEvents() {
      this.getDuration();
    },
  },

  mounted() {
    this.$store.commit('SET_NAV_TABS', [
      { label: 'Karte', to: '/' },
      { label: 'Ereignisse', to: '/events' },
    ]);

    this.$store.dispatch('GET_ALL_EVENTS', false);
    this.$store.dispatch('GET_STATS');
  },

  methods: {
    resolveEvent(event, index) {
      if (!this.$store.state.gridAreas.allEvents[index].resolved) {
        // eslint-disable-next-line
        const confirm = window.confirm('Wurde die Störung wirklich behoben?');
        if (confirm) {
          this.showEvents = false;
          this.$store.dispatch('RESOLVE_EVENT_BY_ID', event)
            .then(() => {
              this.$store.state.gridAreas.allEvents[index].resolved = true;
            });
          this.$store.dispatch('GET_STATS');
        }
      }
    },
    resolveAllEvents() {
      // eslint-disable-next-line
      const confirm = window.confirm('Wurden die Störungen wirklich behoben?');
      if (confirm) {
        this.$store.dispatch('RESOLVE_ALL_EVENTS')
          .then(() => {
            this.$store.state.gridAreas.allEvents.map((event) => {
              event.resolved = true;
            });
            this.$store.dispatch('GET_STATS');
          });
      }
    },
    reloadEvents() {
      this.$store.dispatch('GET_ALL_EVENTS', false);
      this.$store.dispatch('GET_STATS');
    },
    openGridArea(id) {
      this.$router.push(`/area/${id}`);
    },
    getDuration() {
      let lastEvent = null;

      const hasCritical = this.allEvents.filter(e => !e.resolved && e.severity === 'critical').length > 0;
      if (!hasCritical) {
        const calcDuration = () => {
          this.interval = setInterval(() => {
            const now = this.$moment();
            const duration = this.$moment.duration(now.diff(lastEvent));
            this.duration.hours = parseInt(duration.asHours(), 10);
            this.duration.minutes = parseInt(duration.asMinutes(), 10) % 60;
            this.duration.seconds = parseInt(duration.asSeconds(), 10) % 60;
            return true;
          }, 1000);
        };
        lastEvent = this.$moment(this.allEvents[0].updated_at);
        clearInterval(this.interval);
        calcDuration();
      } else {
        this.duration.hours = 0;
        this.duration.minutes = 0;
        this.duration.seconds = 0;
        clearInterval(this.interval);
      }
    },
  },
};
</script>
